import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import LinkIcon from '@material-ui/icons/Link';
import { Link } from '../Link/Link.esm.js';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

const useIconStyles = makeStyles(
  (theme) => ({
    link: {
      display: "grid",
      justifyItems: "center",
      gridGap: 4,
      textAlign: "center"
    },
    disabled: {
      color: theme.palette.text.secondary,
      cursor: "default"
    },
    primary: {
      color: theme.palette.primary.main
    },
    secondary: {
      color: theme.palette.secondary.main
    },
    label: {
      textTransform: "uppercase",
      fontWeight: theme.typography.fontWeightBold,
      letterSpacing: 1.2
    }
  }),
  { name: "BackstageIconLinkVertical" }
);
function IconLinkVertical({
  color = "primary",
  disabled = false,
  href = "#",
  icon = /* @__PURE__ */ jsx(LinkIcon, {}),
  label,
  onClick,
  title
}) {
  const classes = useIconStyles();
  if (disabled) {
    return /* @__PURE__ */ jsxs(Box, { title, className: classNames(classes.link, classes.disabled), children: [
      icon,
      /* @__PURE__ */ jsx(
        Typography,
        {
          variant: "caption",
          component: "span",
          className: classes.label,
          children: label
        }
      )
    ] });
  }
  return /* @__PURE__ */ jsxs(
    Link,
    {
      title,
      className: classNames(classes.link, classes[color]),
      to: href,
      onClick,
      children: [
        icon,
        /* @__PURE__ */ jsx(Typography, { variant: "caption", component: "span", className: classes.label, children: label })
      ]
    }
  );
}

export { IconLinkVertical };
//# sourceMappingURL=IconLinkVertical.esm.js.map
